import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
    selector: 'kt-panel',
    template: `<div class="card" [style.margin-bottom.px]="10">
  <h5 class="card-header">{{ props.label }}</h5>
  <div class="card-body">
    <ng-container #fieldComponent></ng-container>
  </div>
</div>
`,
    standalone: false
})
export class FormlyWrapperPanelComponent extends FieldWrapper {

}
